import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type StorageMode = 'CloudS3' | 'Local';

interface TenantState {
  tenantId: string | null;
  slug: string | null;
  companyName: string | null;
  displayName: string | null;
  planName: string | null;
  sessionLimit: number;
  storageMode: StorageMode;
  canonicalHost: string | null;
  logoUrl: string | null;
  setTenant: (data: Partial<TenantState>) => void;
  clearTenant: () => void;
}

// Safe localStorage wrapper
const safeStorage = createJSONStorage(() => ({
  getItem: (name: string) => {
    try {
      return localStorage.getItem(name);
    } catch (e) {
      console.warn(`[tenantStore] Failed to read localStorage key "${name}":`, e);
      return null;
    }
  },
  setItem: (name: string, value: string) => {
    try {
      localStorage.setItem(name, value);
    } catch (e) {
      console.warn(`[tenantStore] Failed to write localStorage key "${name}":`, e);
    }
  },
  removeItem: (name: string) => {
    try {
      localStorage.removeItem(name);
    } catch (e) {
      console.warn(`[tenantStore] Failed to remove localStorage key "${name}":`, e);
    }
  },
}));

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      tenantId: null,
      slug: null,
      companyName: null,
      displayName: null,
      planName: null,
      sessionLimit: 1,
      storageMode: 'CloudS3',
      canonicalHost: null,
      logoUrl: null,
      setTenant: (data) => set((s) => ({ ...s, ...data })),
      clearTenant: () =>
        set({
          tenantId: null,
          slug: null,
          companyName: null,
          displayName: null,
          planName: null,
          sessionLimit: 1,
          storageMode: 'CloudS3',
          canonicalHost: null,
          logoUrl: null,
        }),
    }),
    { name: 'wl-tenant', storage: safeStorage }
  )
);
